<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop>
      <div class="modal__head">
        <h3 class="modal__title">Редактировать документ</h3>
        <div class="close" @click.stop="closeModal">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="modal__row">
          <AppSelect title="Вид документа"
                     placeholder="Укажите вид документа"
                     :value="document.type"
                     :options="documentTypesList"
                     @value-changed="setType"
          />
        </div>
        <div class="modal__row">
          <AppInput title="Гражданство"
                    :value="document.citizenship"
                    :valid="{}"
                    @value-changed="setCitizenship"
          />
        </div>
        <div class="modal__row">
          <div class="page__item">
            <AppInput title="Серия"
                      :value="document.serial"
                      :valid="{}"
                      width="100px"
                      @value-changed="setSerial"
            />
          </div>
          <div class="page__item">
            <AppInput title="Номер"
                      :value="document.number"
                      :valid="{}"
                      width="268px"
                      @value-changed="setNumber"
            />
          </div>
        </div>
        <div class="modal__row">
          <AppTextarea title="Кем выдан"
                       :value="document.issued_by"
                       :valid="{}"
                       inputHeight="70px"
                       @value-changed="setIssuedBy"
          />
        </div>
        <div class="modal__row">
          <AppInput title="Код подразделения"
                    :value="document.code"
                    :valid="{}"
                    @value-changed="setCode"
          />
        </div>
        <div class="modal__row mb-40">
          <AppInputDate title="Дата выдачи"
                        :value="document.date_at"
                        type="single"
                        :valid="{}"
                        @value-changed="setDateAt"
          />
        </div>
        <div class="modal__button-wrap">
          <div class="modal__button">
            <AppButton title="Сохранить" type="main" @click.native="updateDocument"/>
          </div>
          <div class="modal__button">
            <AppButton title="Отмена" type="alt" @click.native="closeModal"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '../button/AppButton.vue'
import AppInput from '../input/AppInput'
import AppSelect from '../input/AppSelect'
import AppInputDate from '@/components/page/input/AppInputDate'
import AppTextarea from '@/components/page/input/AppTextarea'

export default {
  name: 'user-document-update-modal',
  components: {
    AppTextarea,
    AppInputDate,
    AppSelect,
    AppInput,
    AppButton
  },
  props: {
    document: Object
  },
  computed: {
    documentTypesList () {
      return this.$store.getters['[dictionaries] usersDocumentTypesList']
    }
  },
  methods: {
    loadOptions () {
      this.$store.dispatch('[dictionaries] getDocumentTypes')
    },
    updateDocument () {
      this.$store.dispatch('updateUserDocument', this.document.id)
    },
    closeModal () {
      this.$emit('close-modal')
    },
    setType (type) {
      this.$store.dispatch('updateUserDocumentType', type)
    },
    setCitizenship (citizenship) {
      this.$store.dispatch('updateUserDocumentCitizenship', citizenship)
    },
    setSerial (serial) {
      this.$store.dispatch('updateUserDocumentSerial', serial)
    },
    setNumber (number) {
      this.$store.dispatch('updateUserDocumentNumber', number)
    },
    setIssuedBy (issuedBy) {
      this.$store.dispatch('updateUserDocumentIssuedBy', issuedBy)
    },
    setCode (code) {
      this.$store.dispatch('updateUserDocumentCode', code)
    },
    setDateAt (date) {
      this.$store.dispatch('updateUserDocumentDateAt', date)
    }
  },
  mounted () {
    this.loadOptions()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  align-items: flex-start;
  padding-top: 20px;
  padding-bottom: 100px;
  overflow: auto;
}

.modal {
  max-width: 500px;

  &__row {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    margin-bottom: 20px;
  }

  &__text {
    text-align: center;
    color: $font_color_second;
    margin-bottom: 20px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }

  &__button {
    margin-right: 16px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
